var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BasePopup', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "barcode-popup-content"
  }, [_c('div', {
    staticClass: "barcode-display"
  }, [_c('img', {
    staticClass: "barcode-image",
    attrs: {
      "src": "/api/barcode/".concat(_vm.serialNumber),
      "alt": "條碼"
    }
  })]), _c('div', {
    staticClass: "barcode-serial-section"
  }, [_c('span', {
    staticClass: "barcode-serial-text"
  }, [_vm._v(_vm._s(_vm.serialNumber))]), _c('CopyButton', {
    attrs: {
      "text": _vm.serialNumber,
      "variant": "barcode",
      "success-message": "序號已複製到剪貼簿"
    },
    on: {
      "copied": function copied($event) {
        return _vm.$emit('copied', $event);
      }
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }